export default "__VITE_ASSET__g$BD_0ST__"